"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./util");
exports.default = {
    genesis: (ticker, name, documentUrl, documentHash, decimals, mintBatonVout, quantity) => util_1.createOpReturnGenesis(0x01, ticker, name, documentUrl, documentHash, decimals, mintBatonVout, quantity),
    mint: (tokenIdHex, mintBatonVout, quantity) => util_1.createOpReturnMint(0x01, tokenIdHex, mintBatonVout, quantity),
    send: (tokenIdHex, slpAmounts) => util_1.createOpReturnSend(0x01, tokenIdHex, slpAmounts),
};
